<template>
  <layout-content :total="total">
    <!-- 面包屑的插槽 -->
    <breadcrumb slot="breadcrumb"></breadcrumb>
    <div slot="back" class="back" @click="back">返回</div>
    <div slot="content">
      <!-- 搜索和新增 -->
      <div class="d-f a-c j-b">
        <a-form-model ref="queryForm" :model="queryParams" layout="inline">
          <a-form-model-item label="菜单名称" prop="menuName">
            <a-input
              v-model="queryParams.menuName"
              placeholder="请输入菜单名称"
              allowClear
              @keyup.enter.native="handleQuery"
            />
          </a-form-model-item>
          <a-form-model-item label="菜单状态" prop="status">
            <a-select
              v-model="queryParams.status"
              allowClear
              placeholder="请选择菜单状态"
              style="width: 180px"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-select-option :value="0"> 启用 </a-select-option>
              <a-select-option :value="1"> 禁用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="handleQuery" v-hasPermi="['acl:menu:query']"
              >搜索</a-button
            >
            <a-button @click="resetQuery" class="ml10" v-hasPermi="['acl:menu:query']">
              重置
            </a-button>
          </a-form-model-item>
        </a-form-model>
        <div>
          <a-button
            type="primary"
            @click="handleAdd"
            icon="plus"
            v-hasPermi="['acl:menu:add']"
            >新增</a-button
          >
        </div>
      </div>
      <!--表格-->
      <a-table
        :columns="columns"
        rowKey="id"
        :data-source="data"
        :pagination="false"
        :scroll="{ x: 1300 }"
        class="mt20"
      >
        <span slot="icon" slot-scope="text">
          <img :src="text" width="16px" v-if="text != '#'" />
        </span>
        <span slot="status" slot-scope="text">
          <a-tag :color="text === 0 ? '#009FE8' : '#f5222d'">
            {{ text | filterStatus }}
          </a-tag>
        </span>
        <span slot="hidden" slot-scope="text">
          {{ text | filterHidden }}
        </span>
        <span slot="isFrame" slot-scope="text">
          {{ text | filterIsFrame }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleAdd(record)" v-hasPermi="['acl:menu:add']">新增</a>
          <a-divider type="vertical" />
          <a @click="handleUpdate(record)" v-hasPermi="['acl:menu:edit']">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['acl:menu:remove']">删除</a>
        </span>
      </a-table>
      <!--新增和编辑的弹出框-->
      <a-modal
        v-model="visible"
        :title="title"
        @ok="submit"
        @cancel="handleCancel"
        width="700px"
      >
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="上级菜单"
                prop="parentId"
                :label-col="{ span: 4, offset: 0 }"
              >
                <treeselect
                  v-model="form.parentId"
                  :options="menuOptions"
                  :normalizer="normalizer"
                  :show-count="true"
                  placeholder="选择上级菜单"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="菜单类型"
                prop="type"
                :label-col="{ span: 4, offset: 0 }"
              >
                <a-radio-group v-model="form.type">
                  <a-radio :value="1"> 目录 </a-radio>
                  <a-radio :value="2"> 菜单 </a-radio>
                  <a-radio :value="3"> 按钮 </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="菜单名称" prop="menuName">
                <a-input v-model="form.menuName" placeholder="请输入菜单名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="显示排序" prop="orderNum">
                <a-input-number
                  v-model="form.orderNum"
                  placeholder="请输入显示排序"
                  :min="1"
                  style="width: 100%"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" v-if="form.type != 3">
              <a-form-model-item
                label="菜单图标"
                prop="icon"
                :label-col="{ span: 4, offset: 0 }"
              >
                <!-- 图片剪裁以及预览 -->
                <a-row>
                  <a-col :span="24" :style="{ height: '100px', width: '100px' }">
                    <vue-cropper
                      ref="cropper"
                      :img="options.icon"
                      :info="true"
                      :autoCrop="options.autoCrop"
                      :autoCropWidth="options.autoCropWidth"
                      :autoCropHeight="options.autoCropHeight"
                      :fixedBox="options.fixedBox"
                      @realTime="realTime"
                      outputType="png"
                    />
                    <div class="avatar-upload-preview" v-if="canShow">
                      <img :src="previews.url" :style="previews.img" />
                    </div>
                    <div class="avatar-upload-preview" v-else>
                      <img :src="form.icon" class="avatar" />
                    </div>
                  </a-col>
                </a-row>
                <br />
                <!-- 上传，上下左右旋转以及放大缩小 -->
                <a-row>
                  <a-col :lg="2" :md="2">
                    <a-upload
                      action="#"
                      :http-request="requestUpload"
                      :showUploadList="false"
                      :before-upload="beforeUpload"
                      accept="image/*"
                    >
                      <a-button>选择<a-icon type="upload" /></a-button>
                    </a-upload>
                  </a-col>
                  <a-col :lg="{ span: 1, offset: 7 }" :md="2">
                    <a-button icon="plus" @click="changeScale(1)"></a-button>
                  </a-col>
                  <a-col :lg="{ span: 1, offset: 3 }" :md="2">
                    <a-button icon="minus" @click="changeScale(-1)"></a-button>
                  </a-col>
                  <a-col :lg="{ span: 1, offset: 3 }" :md="2">
                    <a-button icon="undo" @click="rotateLeft()"></a-button>
                  </a-col>
                  <a-col :lg="{ span: 1, offset: 3 }" :md="2">
                    <a-button icon="redo" @click="rotateRight()"></a-button>
                  </a-col>
                </a-row>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type === 2">
              <a-form-model-item label="组价路径" prop="component">
                <a-input v-model="form.component" placeholder="请输入组价路径" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type != 1">
              <a-form-model-item label="权限标识" prop="perms">
                <a-input v-model="form.perms" placeholder="请输入权限标识" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type === 2">
              <a-form-model-item label="是否缓存" prop="isCache">
                <a-radio-group v-model="form.isCache">
                  <a-radio :value="0"> 是 </a-radio>
                  <a-radio :value="1"> 否 </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type != 3">
              <a-form-model-item label="是否外链" prop="isFrame">
                <a-radio-group v-model="form.isFrame">
                  <a-radio :value="0"> 是 </a-radio>
                  <a-radio :value="1"> 否 </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type != 3">
              <a-form-model-item label="路由地址" prop="path">
                <a-input v-model="form.path" placeholder="请输入路由地址" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type != 3">
              <a-form-model-item label="菜单状态" prop="status">
                <a-radio-group v-model="form.status">
                  <a-radio :value="0"> 启用 </a-radio>
                  <a-radio :value="1"> 禁用 </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.type != 3">
              <a-form-model-item label="显示状态" prop="hidden">
                <a-radio-group v-model="form.hidden">
                  <a-radio :value="0"> 显示 </a-radio>
                  <a-radio :value="1"> 隐藏 </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </div>
  </layout-content>
</template>

<script>
import LayoutContent from "@/views/layout/content";
import Breadcrumb from "~c/Breadcrumb";
import { getChildrenMenu, menuAddOrUpdate, menuRemove, getMenu } from "@/api/acl/menu.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { VueCropper } from "vue-cropper";
const columns = [
  {
    title: "菜单名称",
    dataIndex: "menuName",
    align: "left",
  },
  {
    title: "图标",
    dataIndex: "icon",
    align: "center",
    width: "100px",
    scopedSlots: { customRender: "icon" },
  },
  {
    title: "显示排序",
    dataIndex: "orderNum",
    align: "center",
    width: "100px",
  },
  {
    title: "权限标识",
    dataIndex: "perms",
    align: "center",
  },
  {
    title: "组件路径",
    dataIndex: "component",
    align: "center",
  },
  {
    title: "菜单状态",
    dataIndex: "status",
    align: "center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "显示状态",
    dataIndex: "hidden",
    align: "center",
    scopedSlots: { customRender: "hidden" },
    width: "100px",
  },
  {
    title: "是否外链",
    dataIndex: "isFrame",
    align: "center",
    scopedSlots: { customRender: "isFrame" },
    width: "100px",
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "250px",
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "MenuData",
  components: { LayoutContent, Breadcrumb, Treeselect, VueCropper },
  filters: {
    filterStatus(val) {
      return ["启用", "禁用"][val];
    },
    filterHidden(val) {
      return ["显示", "隐藏"][val];
    },
    filterIsFrame(val) {
      return ["是", "否"][val];
    },
  },
  data() {
    return {
      //菜单数量
      total: null,
      //父id
      parentId: "",
      //父菜单名称
      menuName: "",
      // 查询参数
      queryParams: {},
      //表格的表头文字
      columns,
      //表格的数据
      data: [],
      //新增和编辑的表单
      form: {
        isCache: 0,
        isFrame: 1,
        status: 0,
        hidden: 0,
      },
      //表单规则
      rules: {
        parentId: [
          {
            required: true,
            message: "请选择上级菜单",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        type: [
          {
            type: "number",
            required: true,
            message: "请选择菜单类型",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        menuName: [
          {
            required: true,
            message: "请输入菜单名称",
            whitespace: true,
            trigger: ["change", "blur"],
          },
          {
            min: 0,
            max: 12,
            message: "菜单名称不能超过12个汉字",
            trigger: ["change", "blur"],
          },
        ],
        component: [
          {
            required: true,
            message: "请输入组价路径",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        perms: [
          {
            required: true,
            message: "请输入权限标识",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        orderNum: [
          {
            type: "number",
            required: true,
            message: "请输入显示排序",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        isCache: [
          {
            type: "number",
            required: true,
            message: "请选择是否缓存",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        isFrame: [
          {
            type: "number",
            required: true,
            message: "请选择是否外链",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        path: [
          {
            required: true,
            message: "请输入路由地址",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "请选择菜单状态",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
        hidden: [
          {
            type: "number",
            required: true,
            message: "请选择显示状态",
            whitespace: true,
            trigger: ["change", "blur"],
          },
        ],
      },
      //label和wrapper的占位
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      //新增和编辑弹出框的标题
      title: "",
      //新增和编辑弹出框的显示隐藏
      visible: false,
      // 菜单树选项
      menuOptions: [],
      //盒子图片裁剪
      options: {
        icon: "", //裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 32, // 默认生成截图框宽度
        autoCropHeight: 32, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
      },
      //盒子图片预览
      previews: {},
      //盒子图片文件
      file: null,
      //是否展示预览图片
      canShow: true,
    };
  },
  methods: {
    //返回上一级
    back() {
      this.$router.go(-1);
    },
    //搜索
    handleQuery() {
      this.queryParams.page = 1;
      this.getChildrenMenu();
    },
    //搜索重置
    resetQuery() {
      this.queryParams.page = 1;
      this.$refs.queryForm.resetFields();
      this.getChildrenMenu();
    },
    //根据父id得到嵌套菜单列表和树状数组
    getChildrenMenu() {
      this.queryParams.parentId = this.parentId;
      getChildrenMenu(this.queryParams).then((res) => {
        let list = res.data;
        this.data = list;
        let arr = JSON.parse(JSON.stringify(list));
        let obj = {};
        obj.menuName = this.menuName;
        obj.id = this.parentId;
        obj.children = arr;
        let arr1 = [];
        arr1.push(obj);
        this.menuOptions = arr1;
      });
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.form = {
        isCache: 0,
        isFrame: 1,
        status: 0,
        hidden: 0,
      };
      this.options.icon = "";
      this.canShow = true;
      this.visible = true;
      this.title = "新增菜单";
      if (row.id) {
        this.form.parentId = row.id;
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.form = {};
      getMenu(row.id).then((res) => {
        this.form = res.data;
        Object.keys(this.form).forEach((key) => {
          if (this.form[key] === null) {
            delete this.form[key];
          }
        });
        this.options.icon = "";
        this.canShow = false;
        this.visible = true;
        this.title = "修改菜单";
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm({
        title: "您确认删除您选中的数据吗？",
        onOk: () => {
          //单个删除
          let arr = [];
          arr.push(row.id);
          menuRemove(arr).then((res) => {
            this.$message.success("删除成功");
            this.getChildrenMenu();
          });
        },
      });
    },
    //新增或编辑确定
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          //修改
          if (this.form.id) {
            //没传图片
            if (!this.canShow) {
              let formdata = this.formdataify(this.form);
              menuAddOrUpdate(formdata).then((res) => {
                this.$message.success("修改成功");
                this.visible = false;
                this.getChildrenMenu();
              });
            } else {
              this.$refs.cropper.getCropBlob((data) => {
                //修改命名
                const time = new Date().getTime();
                const randomName = time + "_" + this.file.name;
                // blob转file
                let file = new window.File([data], randomName, {
                  type: data.type,
                });
                this.form.file = file;
                let formdata = this.formdataify(this.form);
                menuAddOrUpdate(formdata).then((res) => {
                  this.$message.success("新增成功");
                  this.visible = false;
                  this.getChildrenMenu();
                });
              });
            }
          }
          //上传
          else {
            //没有上传盒子图片
            if (this.options.icon === "") {
              let formdata = this.formdataify(this.form);
              menuAddOrUpdate(formdata).then((res) => {
                this.$message.success("新增成功");
                this.visible = false;
                this.getChildrenMenu();
              });
            } else {
              this.$refs.cropper.getCropBlob((data) => {
                const time = new Date().getTime();
                const randomName = time + "_" + this.file.name;
                // blob转file
                let file = new window.File([data], randomName, {
                  type: data.type,
                });
                this.form.file = file;
                let formdata = this.formdataify(this.form);
                menuAddOrUpdate(formdata).then((res) => {
                  this.$message.success("新增成功");
                  this.visible = false;
                  this.getChildrenMenu();
                });
              });
            }
          }
        }
      });
    },
    //新增或编辑取消
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if ((node.children && !node.children.length) || node.children == null) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.menuName,
        children: node.children,
      };
    },
    // 覆盖默认的上传行为
    requestUpload() {},
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 上传预处理
    beforeUpload(file) {
      if (file.type.indexOf("image/") == -1) {
        this.$message.error("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
      } else {
        //如果编辑的时侯上传头像
        if (this.canShow === false) {
          this.canShow = true;
        }
        this.file = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.options.icon = reader.result;
        };
      }
    },
    // 实时预览
    realTime(data) {
      this.previews = data;
    },
    //json对象转换为formData格式
    formdataify(params) {
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });
      return formData;
    },
  },
  created() {
    this.parentId = this.$route.query.parentId;
    this.menuName = this.$route.query.menuName;
    this.getChildrenMenu();
  },
};
</script>

<style scoped lang="less">
.back {
  color: @primary-color;
  font-weight: normal;
  cursor: pointer;
}
.avatar-upload-preview {
  position: absolute;
  top: 0px;
  left: 110px;
  width: 32px;
  height: 32px;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;
  .avatar {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
